import gql from "graphql-tag";
const field = `
id
name
tel
representedBy
positionRepresentedBy
taxCode
fax
address
accountBank
createdAt
updatedAt
`;

const createCustomer = gql`
  mutation(
    $name: String!
    $tel: String
    $code: String
    $endUserClass: String
    $representedBy: String
    $positionRepresentedBy: String
    $taxCode: String
    $address: String
    $accountBank: String
  ) {
    createCustomer(
      data: {
        name: $name
        code: $code
        endUserClass: $endUserClass
        tel: $tel
        representedBy: $representedBy
        positionRepresentedBy: $positionRepresentedBy
        taxCode: $taxCode
        address: $address
        accountBank: $accountBank
      }
    ) {
      ${field}
    }
  }
`;

const updateCustomer = gql`
  mutation(
    $id: ID!
    $name: String
    $tel: String
    $representedBy: String
    $positionRepresentedBy: String
    $taxCode: String
    $address: String
    $accountBank: String
  ) {
    updateCustomer(
      id: $id
      data: {
        name: $name
        tel: $tel
        representedBy: $representedBy
        positionRepresentedBy: $positionRepresentedBy
        taxCode: $taxCode
        address: $address
        accountBank: $accountBank
      }
    ) {
      ${field}
    }
  }
`;

const deleteCustomer = gql`
  mutation($id: ID!) {
    deleteCustomer(id: $id) {
      id
    }
  }
`;

const getListCustomer = gql`
  query($limit: Int, $page: Int, $query: String) {
    getListCustomer(query: $query paging: { limit: $limit, page: $page }) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getDetailCustomer = gql`
  query($id: ID!) {
    getDetailCustomer(id: $id) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getListCustomer,
  getDetailCustomer,
};
